import React from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { FORM_MODES } from '../../constants/commonConstants';
import Tenantdetailsform from './tenantdetailsform';


const TenantDetailPage = () => {
  const { unitId, propertyId } = useParams();

  const location = useLocation();
  console.log('location', location)
  const isEditMode = location.pathname.includes("edit-tenant");

  const mode = isEditMode ? FORM_MODES.EDIT : FORM_MODES.ADD;

  return (
    <div className="p-30">
      <Tenantdetailsform unitId={unitId} mode={mode} propertyId={propertyId}/>
    </div>
  );
};

export default TenantDetailPage;
